import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import "./i18n";
import { App } from "./app";
import { createSession } from "./auth/create-session";

// Einstiegspunkt: Anmeldung vorbereiten, bestehende Sitzung wiederherstellen,
// dann die App rendern. "async function" erlaubt await (warten auf Promises).
async function start(): Promise<void> {
  const container = document.getElementById("root");
  if (!container) throw new Error("#root fehlt in index.html");
  const root = createRoot(container);

  try {
    const session = await createSession();
    const initialUser = await session.restore();
    root.render(
      // StrictMode prüft in der Entwicklung auf typische Fehler (z. B. indem
      // es Effekte doppelt ausführt). Im Produktions-Build ohne Wirkung.
      <StrictMode>
        <App session={session} initialUser={initialUser} />
      </StrictMode>,
    );
  } catch (error) {
    // Fehlkonfiguration (z. B. fehlende Cognito-Werte): klar anzeigen statt weißer Seite.
    console.error(error);
    root.render(
      <p style={{ padding: 24, fontFamily: "system-ui" }}>
        Ortura konnte nicht gestartet werden. Details in der Browser-Konsole.
      </p>,
    );
  }
}

void start();
